import { KeyCodes } from '../../../utils/aria';
import { msg, str } from '@lit/localize';
import { NorthStarElement, html, define } from '../../../northstar';
import { RAF, isTouch, getOS } from '../../../utils';
import { range } from 'lit/directives/range.js';
import { map } from 'lit/directives/map.js';
import styles from './login.css';

function template(elem) {
  const { state, scrolled, isMobile, size, selectedItem, selected, show, os } = elem;

  function renderSlot() {
    const { os } = elem;
    console.log(os)
    /*
    switch (os) {
      case 'Android':
        return html`<slot name="android"></slot>`;
      case 'iOS':
        return html`<slot name="ios"></slot>`;
      case 'other':
        return html`<slot name="other"></slot>`;
      default:
        return html`<slot name="other"></slot>`;
    }
    */
    return html`<slot name="other"></slot>`;
  }
  function renderDownloadButton() {
    function getStoreButton() {
      switch (os) {
        case 'Android':
          return html`<oportun-graphic name="playstore-logo-mark" />`;
        case 'iOS':
          return html`<oportun-graphic name="appstore-logo" />`;
        default:
          return html``;
      }
    }

    const className = (os === 'Android' || os === 'iOS' ? os : 'other').toLowerCase();

    return html`<div class="download appstore ${className}">
      <span>
        <a
          href="https://app.oportun.com/download"
          target="_blank"
          data-event_tracking="link click"
          data-event_tracking_label="Get app"
          data-event_tracking_section="Header"
          >${getStoreButton()} ${msg('Get app')}</a
        ></span
      >
    </div>`;
  }

  function renderMegaMenu() {
    return html`
      <div class="mega-menu">
        <div class="menu-content" @pointerleave=${elem.menuHide} >
          <slot name="menu-${selected}"></slot>
        </div>
        <div class="backdrop"></div>
      </div>
    `;
  }

  function toggleMenu(index, state) {
    return (evt) => {
      evt.stopPropagation();
      if (state) {
        elem.menuOpen(evt, evt.currentTarget.parentNode, index);
      } else {
        elem.menuHide(evt, evt.currentTarget.parentNode, index);
      }
    };
  }

  function renderDesk() {
    
    return html`
      <div class="navigation">
        <div class="head ">
          <div class="nav">
            ${map(
              range(+size),
              (i) => html` <div class="navitem ${selectedItem.has(i + 1) ? 'selected' : ''}">
                <div class="item" @pointerenter="${toggleMenu(i + 1, true)}" >
                  <slot name="navitem-${i + 1}"></slot>
                  <oportun-icon name="${selectedItem.has(i + 1) ? 'arrow-up' : 'arrow-down'}" />
                </div>
              </div>`,
            )}
          </div>
          
        </div>
        ${show ? renderMegaMenu() : ''}
      </div>
    `;
  }

  function toggleItem(index) {
    return (evt) => {
      elem.toggleItem(evt, evt.currentTarget.parentNode, index);
    };
  }

  function toggleMobileMenu(evt) {
    elem.toggleMobileMenu(evt);
  }

  function renderMobile(){    
    return html`
    <div class="head ${os}">
      <div class="actions">
        <span
          @click=${toggleMobileMenu}
          data-event_tracking="button click"
          data-event_tracking_label="Log In"
          data-event_tracking_section="Header"
          class="btn btn--small btn--v2 btn--outline"
        >
          ${renderSlot()}
        </span>
      </div>
    </div>
    <dialog>
        
        <div class="navigation mobile">
          <div class="navroot">
            <nav class="nav">
              <div class="nav-container">
                <div class="list">
                
                ${map(
                  range(+size),
                  (i) => html` 
                    <div class="navitem selected">
                      <div class="" >
                        <div class="topmenu">
                          <div class="logo">
                            <slot name="logo"></slot>
                          </div>
                          <div>
                            ${renderDownloadButton()}
                            <div class="hamburger">
                              <span
                                @click=${toggleMobileMenu}
                                data-event_tracking="link click"
                                data-event_tracking_label="Toggle menu"
                                data-event_tracking_section="Header"
                              >
                                <oportun-icon name="hamburger" />
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="megamenu"><slot name="menu-${i + 1}"></slot></div>
                    </div>`,
                )}
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </dialog>
    `;
  }

  return html`${isMobile ? renderMobile() : '' }`

}

export default class LoginButton extends NorthStarElement {
  static styles = styles;

  static template = template;

  static properties = {
    url: { type: String },
    os: { type: String },
    isDropdown: { type: Boolean },
    isMobile : { type: Boolean},
    selected: { type: 'string' },
    size: { type: Number },
    selectedItem: { type: Set },
    show: { type: 'boolean' },
  };

  constructor() {
    super();
    
    this.selectedItem = new Set([]);
    this.selected = 1;
    this.show = false;

    if (window.innerWidth <= 1070) {
      this.mobileMenu = true;
    } else {
      this.mobileMenu = false;
    }
  }

  handleClick(e) {}
  getSlottedChildren(selector) {
    const slot = this.shadowRoot.querySelector(`slot[name="${selector}"]`);
    return slot.assignedElements({ flatten: true });
  }

  lockScroll() {
    const doc = document.body;
    doc.classList.add('scroll-lock');
  }

  unlockScroll() {
    const doc = document.body;
    doc.classList.remove('scroll-lock');
  }

  toggleMobileMenu(e) {
    const dialog = this.$('dialog');

    const doc = document.body;

    const head = this.$('.head');
    const header = this.parentElement;
    const bounds = head.getBoundingClientRect();

    this.style.setProperty('--dialog-top', `${bounds.bottom + 1}px`);
    dialog.style.setProperty('--dialog-top', `${bounds.bottom + 1}px`);
    dialog.style.setProperty('--dialog-height', `${window.innerHeight - (bounds.bottom + 1)}px`);

    if (dialog.open) {
      dialog.close();
    } else {
      dialog.showModal();

      doc.scrollTop = 1;
      this.lockScroll();

      function closeDialog(e) {
        e.stopPropagation();

        if (e.target === dialog) {
          e.stopPropagation();
          dialog.close();
        }
      }

      const onScroll = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('scroll', e);
      };

      const onClose = (e) => {
        dialog.removeEventListener('click', closeDialog);
        dialog.removeEventListener('close', onClose);
        this.unlockScroll();
      };

      dialog.addEventListener('close', onClose);
      dialog.addEventListener('click', closeDialog);
    }

    this.sendAnalyticsEvent({
      target: e.currentTarget,
      originalEvent: e,
      data: { event: 'Link click', label: 'Toggle menu', section: 'Header' },
    });
  }

  menuHide(e, item, index) {
    const hide = () => {
      if (this.anim) {
        this.anim.cancel();

        const mega = this.renderRoot.querySelector('.mega-menu');
        const anim = mega.animate([{ opacity: 0 }], {
          duration: 400,
          fill: 'both',
        });

        anim.finished.then(() => {
          this.show = false;
          this.anim = null;
          this.exitAnim = null;

          this.triggerEvent('menuhide', { target: this });
        });

        this.exitAnim = anim;
      } else {
        this.show = false;
      }
    };

    this.closeTimer = setTimeout(hide, 200);
  }

  menuOpen(e, item, index) {
    if (this.closeTimer) {
      clearInterval(this.closeTimer);
    }

    if (this.selected === index && this.show) {
      return;
    }

    let duration = 200;

    this.selected = index;
    if (this.show) {
      duration = 0;
    }
    this.show = true;

    setTimeout(() => {
      const mega = this.renderRoot.querySelector('.mega-menu');
      const anim = mega.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration,
        fill: 'both',
      });
      this.anim = anim;
    });
  }

  toggleItem(e, item, index) {
    e.preventDefault();

    if (this.selectedItem.has(index)) {
      this.selectedItem.delete(index);
    } else {
      this.selectedItem.add(index);
    }
    this.requestUpdate();
    this.sendAnalyticsEvent({
      target: e.currentTarget,
      originalEvent: e,
      data: { event: 'Link click', label: 'Toggle item', section: 'Header' },
    });
  }

  requestUpdate(name, oldValue) {
    if (name === 'mobileMenu') {
      if (this.mobileMenu) {
        this.classList.add('mobile');
      } else {
        this.classList.remove('mobile');
      }
    }

    return super.requestUpdate(name, oldValue);
  }

  async attachedCallback() {
    this.os = getOS();
    const ro = this.resizeObserver(({ width }) => {
      const dialog = this.$('dialog');
      if (dialog && dialog.open) {
        dialog.close();
      }

      if (this.show) {
        this.show = false;
      }

      if (window.innerWidth <= 1070) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
    return () => {
      ro.cancel();
    };
  }

}

define('login-button', LoginButton);
